import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '46',
  height: '44',
  viewBox: '0 0 46 44'
}, [
  h('path', {
    d: 'M36.5 28.8c.1 0 9.5-1.3 9.5-10.6 0-2.9-1.1-5.6-3.2-7.6-1.9-1.9-4.4-2.9-7.1-2.9C33.2 3 28.3 0 23 0 15.8 0 9.7 5.4 8.8 12.5c-2.1-.1-4.1.5-5.7 1.8-1.9 1.6-3 3.9-3 6.3s.7 4.3 2.2 5.7c2.4 2.4 6 2.5 6.5 2.5',
    fill: '#c0f2d6'
  }),
  h('path', {
    d: 'M42.8 10.6c-1.9-1.9-4.4-2.9-7.1-2.9C33.2 3 28.3 0 23 0 15.8 0 9.7 5.4 8.8 12.5c-2.1-.1-4.1.5-5.7 1.8-1.9 1.6-3 3.9-3 6.3s.7 4.3 2.2 5.7c2.4 2.4 6 2.5 6.5 2.5.6 0 1-.5 1-1s-.5-1-1-1c0 0-3.1 0-5.1-1.9-1-1-1.6-2.5-1.6-4.3 0-1.9.8-3.6 2.3-4.8 1.4-1.2 3.3-1.6 5.2-1.2.3.1.6 0 .8-.2.2-.2.4-.4.4-.7C11 7.1 16.5 2 23 2c4.8 0 9.1 2.8 11.2 7.1.2.4.5.6.9.6 2.3-.1 4.6.8 6.2 2.4 1.7 1.6 2.6 3.8 2.6 6.2 0 7.4-7.4 8.5-7.7 8.6-.5.1-.9.6-.9 1.1.1.5.6.9 1.1.9.1 0 9.5-1.3 9.5-10.6.1-3-1-5.7-3.1-7.7z',
    fill: '#0eb87f'
  }),
  h('path', {
    d: 'M20.3 36.3L16 40.6V25c0-.6-.4-1-1-1s-1 .4-1 1v15.6l-4.3-4.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l6 6c.1.1.2.2.3.2.1.1.3.1.4.1s.3 0 .4-.1c.1-.1.2-.1.3-.2l6-6c.4-.4.4-1 0-1.4s-1-.4-1.4 0zM35.7 23.3l-6-6c-.1-.1-.2-.2-.3-.2-.2-.1-.5-.1-.8 0-.1.1-.2.1-.3.2l-6 6c-.4.4-.4 1 0 1.4s1 .4 1.4 0l4.3-4.3V38c0 .6.4 1 1 1s1-.4 1-1V20.4l4.3 4.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4z',
    fill: '#0eb87f'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/page-apis.es6.js